module.exports = __webpack_public_path__ + "img/bin-hover.771b4434.svg";